export default __webpack_public_path__ + "static/media/lato-blackitalic.ea2cb30b.woff2";